@if (visible()) {
    <div class="modal-overlay z-9999" @fadeIn @fadeOut>
        <div loading-icon class="text-center"></div>
        <div class="overlay-text">
            {{ text }}
        </div>
    </div>
}